import { render, staticRenderFns } from "./ZeroState.vue?vue&type=template&id=f61d3a2e&scoped=true&lang=pug&"
import script from "./ZeroState.vue?vue&type=script&lang=js&"
export * from "./ZeroState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61d3a2e",
  null
  
)

export default component.exports